import React from 'react';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

/*
Props:
dispositivo
*/
export default class extends React.Component {
  render() {
    let { dispositivo, userRoles, deleteDevice, acceptDevice, requestPhoto, goToTasks } = this.props;
    return (
      <MaterialUI.ListItem
        disabled
        className="ptb-10"
        key={dispositivo.get('id')}
        primaryText={
          <Row>
            <Col md="2">
              <p className="iconBigBig blue" id={dispositivo.get('id')}>
                {dispositivo.get('numero')}
              </p>
              <FontAwesome name="mobile" className="iconBig" />
            </Col>
            <Col md="6">
              <Row>
                <Col md="12">
                  <p className="title blue"> {dispositivo.get('nombre')} </p>
                  <p>Marca: {dispositivo.get('marca')} </p>
                  <p>Modelo: {dispositivo.get('modelo')} </p>
                  <p>Fecha agregado: {moment(dispositivo.get('fechaCreado')).format('DD/MM HH:mm')} </p>
                </Col>
              </Row>
            </Col>
            <Col md="4">
              {userRoles && userRoles.find((v) => v == 'admin' || v == 'devAdmin' || v == 'administrador_vehiculos') && (
                <Row className="listIcon">
                  {!dispositivo.get('aprobado') ? (
                    <div>
                      <MaterialUI.FlatButton className="listIcon" icon={<FontAwesome className="iconBig green" name="check" />} onTouchTap={() => acceptDevice(dispositivo.get('id'))} />
                      <MaterialUI.FlatButton className="listIcon" icon={<FontAwesome className="iconBig red" name="trash" />} onTouchTap={() => deleteDevice(dispositivo.get('id'))} />
                    </div>
                  ) : (
                    <div className="listIcon">
                      <MaterialUI.FlatButton className="listIcon" icon={<FontAwesome className="iconBig blue" name="check" />} disabled />
                      <MaterialUI.IconMenu
                        iconButtonElement={
                          <MaterialUI.IconButton touch={true}>
                            <MoreVertIcon />
                          </MaterialUI.IconButton>
                        }
                      >
                        <MaterialUI.MenuItem className="textCenter" onTouchTap={() => goToTasks(dispositivo.get('id'))}>
                          <FontAwesome name="tasks" className="iconColor" /> Ver tareas
                        </MaterialUI.MenuItem>
                        <MaterialUI.MenuItem className="textCenter" onTouchTap={() => requestPhoto(dispositivo)}>
                          <FontAwesome name="camera" className="green" /> Tomar foto
                        </MaterialUI.MenuItem>
                        <MaterialUI.MenuItem className="textCenter" onTouchTap={() => deleteDevice(dispositivo.get('id'))}>
                          <FontAwesome name="trash" className="red" /> Eliminar
                        </MaterialUI.MenuItem>
                      </MaterialUI.IconMenu>
                    </div>
                  )}
                </Row>
              )}
            </Col>
          </Row>
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// src/modules/dispositivos/components/itemList.js